import { useState } from "react";

import {
  Flex,
  Heading,
  Image,
  Spacer,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import ServicesEditDrawer from "../../components/drawer/ServiceEditDrawer";
import FilterCasestudyByLinkedTable from "../../components/FilterCasestudyByLinked/FilterCasestudyByLinkedTable";

const FilterCasestudyLinkedManagement = () => {
  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [searchQuery, setSearch] = useState("");

  // useEffect(() => {
  //   // if (!busy && !(masterCategory || []).length) {
  //   dispatch({ type: REQUEST_MASTER_CASESTUDY,

  //    });
  //   console.log("dispatched");

  //   // }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  return (
    <>
      <VStack top={5} position="relative" key={"vStack"}>
        <Flex w="92%" alignItems="center" justifyContent="space-between">
          <Heading ml="8" size="md" fontWeight="semibold" color="black.400">
            Linked Casestudy management
          </Heading>
          <Spacer></Spacer>
          <Heading size="sm" fontWeight="semibold">
            <Flex alignItems="center" gap={2}>
              <Image
                borderRadius="full"
                boxSize="50px"
                src="/user_logo.jpg"
                alt="Dan Abramov"
              />
              <Text>Admin</Text>
            </Flex>
          </Heading>
        </Flex>
      </VStack>
      <FilterCasestudyByLinkedTable query={searchQuery} />
      {isOpen && <ServicesEditDrawer isOpen onClose={onClose} />}
    </>
  );
};

export default FilterCasestudyLinkedManagement;
